function fontSizes() {
  let styles = '';

  for (let i = 0; i < 200; i += 1) {
    styles += `
       .font--${i} {
         font-size: ${i}px !important;
       }
     `;
  }

  return styles;
}

export default fontSizes;
